import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Homepage from "../HomePage/HomePage";
import BlogPage from "../BlogPage/BlogPage";
import BlogDetails from "../BlogDetails/BlogDetails";
import AboutPage from "../AboutPage/AboutPage";
import ContactPage from "../ContactPage/ContactPage";
// import TokenPage from '../TokenPage/TokenPage';
import SigninPage from "../SigninPage/SigninPage";
import SignupPage from "../SignupPage/SignupPage";
import TermsService from "../TermsService/TermsService";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";
import CookiePolicy from "../CookiePolicy/CookiePolicy";
import FaqPage from "../Faq/Faq";
import Blockchain from "../Blockchain/Blockchain";
import Disclaimer from "../Disclaimer/disclaimer";
import TopCoinUKWallets from "../TopCoinUKWallets/TopCoinUKWallets";
import TopCoinPolicy from "../TopCoinPolicy/TopCoinPolicy";
import EternityCoin from "../EternityCoin/EternityCoin";
import RewardOptions from "../Mywallet/RewardOptions";
import TopCoinUKBanyUnit from "../TopCoinUKBanyUnit/TopCoinUKBanyUnit";
import TopCoinUKTax from "../TopCoinUKTax/TopCoinUKTax";
import TUCKCustomerUnit from "../TUCKCustomerUnit/TUCKCustomerUnit";
import YoungEarners from "../YoungEarners/YoungEarners";
import TermsServiceW from "../TermsService/TermsServiceW";
import PrivacyPolicyW from "../PrivacyPolicy/PrivacyPolicyW";
import LoginPage from "../SigninPage/Loginpage";
import EditProfile from "../EditProfile/EditProfile.js";
import TransactionHistory from "../../components/TransactionHistory/TransactionHistory.jsx";
import Wallet from "../Wallet/Wallet.js";
import CashWallet from "../cashwallet/cashwallet.js";
import ForgotPassword from "../ForgotPassword/Forgot-Password.js";
import VerifyEmail from "../VerifyEmail/VerifyEmail.js";
import CreateNewPassword from "../CreateNewPassword/CreateNewPassword.js";
import CustomerForm from "../customerform/CustomerForm.js";
import VerifyEmailC from "../VerifyEmailC/VerifyEmail.js";
import UserProfileWallet from "../UserProfileWallet/UserProfileWallet.js";
import GoogleCallback from "../../components/GoogleCallback/GoogleCallback.js";
import AdvertisingAgent from "../AdvertisingAgent/AdvertisingAgent.js";
import CustomerAdvertisingAgentAgreement from "../CustomerAdvertisingAgentAgreement/CustomerAdvertisingAgentAgreement.js";
import RetailAgentAgreement from "../RetailAgentAgreement/RetailAgentAgreement.js";
import CustomerRulesAndRegulations from "../CustomerRulesAndRegulations/CustomerRulesAndRegulations.js";
import WorkWithTCUK from "../WorkWithTCUK/WorkWithTCUK.js";
import CreateRetailBusiness from "../CreateRetailBusiness/CreateRetailBusiness.js";
import CreateRetailAgent from "../CreateRetailAgent/CreateRetailAgent.js";
import VerifyEmailA from "../VerifyEmailA/VerifyEmail.js";
import VerifyEmailR from "../VerifyEmailR/VerifyEmail.js";
import ForgotPasswordA from "../ForgotPasswordA/Forgot-Password.js";
import ForgotPasswordR from "../ForgotPasswordR/Forgot-Password.js";
import VerifyEmailRP from "../VerifyEmailRP/VerifyEmail.js";
import VerifyEmailAP from "../VerifyEmailAP/VerifyEmail.js";
import CreateNewPasswordA from "../CreateNewPasswordA/CreateNewPassword.js";
import CreateNewPasswordR from "../CreateNewPasswordR/CreateNewPassword.js";
import MiniAgentReferralHistory from "../MiniAgentReferralHistoty/MiniAgentReferralHistory.js";
import MiniAgentTransactionHistory from "../MiniAgentTransactionHistory.js/MiniAgentTransactionHistory.js";
import LoginHeaderR from "../../components/header/LoginHeaderR.js";
import WalletR from "../RetailBusinessPortal/Wallet.js";
import WalletA from "../RetailAgentPortal/Wallet.js";
import TransactionHistoryR from "../../components/TransactionHistory/TransactionHistoryR.jsx";
import TransactionHistoryA from "../../components/TransactionHistory/TransactionHistoryA.jsx";
import PrivacyPolicyR from "../PrivacyPolicy/PrivacyPolicyR.js";
import PrivacyPolicyA from "../PrivacyPolicy/PrivacyPolicyA.js";
import TermsServiceR from "../TermsService/TermsServiceR.js";
import TermsServiceA from "../TermsService/TermsServiceA.js";
/* import ReferCustomer from "../Refer Customer/ReferCustomer.js"; */
import BusinessAgentReferralHistory from "../MiniAgentReferralHistoty/BusinessAgentReferralHistory.js";
import AgentReferralHistory from "../MiniAgentReferralHistoty/AgentReferralHistory.js";
import AgentLayout from "../../components/RetailerBusinessAgent/AgentLayout";
import ReferralPage from "../RetailAgentPortal/ReferBusiness.js";
import RetailerAgentWallet from "../RetailAgentPortal/RetailerAgentWallet.js";
import BusinessLayout from "../../components/RetailBusiness/BusinessLayout.js";
import RetailBusinessWallet from "../RetailBusinessPortal/RetailBusinessWallet.js";
import ReferAgent from "../RetailAgentPortal/ReferBusinessAgent.js";
import ProtectedRoute from "../RetailAgentPortal/ProtectedRoute.js";
import CustomerLayout from "../../components/Customer/CustomerLayout.js";
import CustomerWallet from "../CustomerPortal/CustomerWallet.js";
import ReferCustomer from "../CustomerPortal/ReferCustomer.js";
import ReferralHistory from "../../components/RetailerBusinessAgent/ReferralHistory.js";
import CustomerReferralHistory from "../../components/Customer/CustomerReferralHistory.js";
import BecomeAgent from "../RetailAgentPortal/BecomeAgent.js";
import CustomerWalletNetwork from "../CustomerPortal/CustomerWalletNetwork.js";
import ActiveRetailers from "../ActiveRetailers/ActiveRetailers.js";
import MyWalletPage from "../MyWalletPage/MyWalletPage.js";
import AuctionsSales from "../AuctionsSales/AuctionsSales";
import QrScanner from "../CustomerPortal/QrScanner.js";
import SeniorAgentsHierarchyPage from "../SigninPage/SeniorAgentsHierarchyPage.jsx";
import BusinessAgentsHierarchyPage from "../WorkWithTCUK/BusinessAgentsHierarchyPage.jsx";
import PremiumCardCollection from "../../components/Customer/PremiumCardCollection.js";
import CaptainTCCard from "../../components/Customer/CaptainTCCard.js";
import CaptainTCCardAgent from "../../components/Customer/CaptainTCCardAgent.js";
import ParentsConsent from "../ParentsConsent/ParentsConsent.js";
import ManualTopCoinWindow from "../RetailBusinessPortal/ManualTopCoinWindow.js";
import MemberLayout from "../../components/Member/MemberLayout.js";
import MemberWallet from "../MemberPortal/MemberWallet.js";
import CreateMember from "../CreateMember/CreateMember.js";
import VerifyEmailM from "../VerifyEmailM/VerifyEmail.js";
import ForgotPasswordM from "../ForgotPasswordM/Forgot-Password.js";
import VerifyEmailMP from "../VerifyEmailMP/VerifyEmail.js";
import CreateNewPasswordM from "../CreateNewPasswordM/CreateNewPassword.js";
import MemberLoginPage from "../MemberPortal/MemberLoginPage.js";
import CaptainTCCards from "../CaptainTCCards/CaptainTCCards.js";
import CaptainTCCashbackCardTermsPage from "../CaptainTCCashbackCardTerms/CaptainTCCashbackCardTerms.js";

import PurchasePage from "../PurchasePage/PurchasePage.js";
import PurchaseCartPage from "../PurchaseCartPage/PurchaseCartPage.js";

// Account Admin Portal
import AccountAdminLogin from "../AccountAdminPortal/AccountAdminLogin.js";
import AccountAdminLayout from "../../components/AccountAdmin/AccountAdminLayout.js";
import Dashboard from "../AccountAdminPortal/Dashboard.js";
import CashbackRequests from "../AccountAdminPortal/CashbackRequests.js";
import CustomerCashbackDetails from "../AccountAdminPortal/CustomerCashbackDetails.js";
import DistributionHistory from "../AccountAdminPortal/DistributionHistory.js";
import ManageUsers from "../AccountAdminPortal/ManageUsers.js";

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          {/* <Route path="young-earners-under-18" element={<YoungEarners />} /> */}
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="privacy_policy" element={<PrivacyPolicyW />} />
          <Route path="terms_conditions" element={<TermsServiceW />} />
          <Route path="topcoin-policy" element={<TopCoinPolicy />} />
          <Route path="eternitycoin" element={<EternityCoin />} />
          <Route path="terms-conditions" element={<TermsService />} />
          <Route path="limit-policy" element={<TermsService />} />
          <Route path="cookie-policy" element={<CookiePolicy />} />
          <Route path="tuck-units" element={<RewardOptions />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog-single/:slug" element={<BlogDetails />} />
          <Route path="customer-unit" element={<TUCKCustomerUnit />} />
          <Route path="baby-unit" element={<TopCoinUKBanyUnit />} />
          <Route path="tax-info" element={<TopCoinUKTax />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="auctions-sales" element={<AuctionsSales />} />
          <Route
            path="auctions-sales/retail-auctions"
            element={<AuctionsSales />}
          />
          <Route
            path="auctions-sales/property-auctions"
            element={<AuctionsSales />}
          />
          <Route
            path="auctions-sales/car-auctions"
            element={<AuctionsSales />}
          />
          <Route
            path="auctions-sales/property-sales"
            element={<AuctionsSales />}
          />
          <Route
            path="auctions-sales/car-sales"
            element={<AuctionsSales />}
          />
          <Route path="blockchain" element={<Blockchain />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="disclaimer" element={<Disclaimer />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="sign_in" element={<LoginPage />} />
          <Route path="sign_up" element={<LoginPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="create-account" element={<CustomerForm />} />
          <Route path="customer/transaction" element={<TransactionHistory />} />
         {/*  <Route path="customer/wallet" element={<Wallet />} /> */}
          <Route path="uk-wallet" element={<UserProfileWallet />} />
          <Route path="cashwallet" element={<CashWallet />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="verify-email" element={<VerifyEmail />} />
          <Route path="auth/google/callback" element={<GoogleCallback />} />
          <Route path="create-new-password" element={<CreateNewPassword />} />
          <Route path="verify-email-c" element={<VerifyEmailC />} />
          <Route path="advertising-agent" element={<AdvertisingAgent />} />
          <Route
            path="customer-advertising-agent-agreement"
            element={<CustomerAdvertisingAgentAgreement />}
          />
          <Route
            path="retail-agent-agreement"
            element={<RetailAgentAgreement />}
          />
          <Route
            path="customer-rules-and-regulations"
            element={<CustomerRulesAndRegulations />}
          />
          <Route path="work-with-tcuk" element={<WorkWithTCUK />} />
          <Route
            path="retail-business-signup"
            element={<CreateRetailBusiness />}
          />
          <Route path="retail-agent-signup" element={<CreateRetailAgent />} />
          <Route path="parents-consent" element={<ParentsConsent />} />
          <Route path="verify-email-a" element={<VerifyEmailA />} />
          <Route path="verify-email-r" element={<VerifyEmailR />} />
          <Route path="forgot-password-a" element={<ForgotPasswordA />} />
          <Route path="forgot-password-r" element={<ForgotPasswordR />} />
          <Route path="verify-email-rp" element={<VerifyEmailRP />} />
          <Route path="verify-email-ap" element={<VerifyEmailAP />} />
          <Route
            path="create-new-password-a"
            element={<CreateNewPasswordA />}
          />
          <Route
            path="create-new-password-r"
            element={<CreateNewPasswordR />}
          />
          <Route
            path="/mini-agent-referral-history"
            element={<MiniAgentReferralHistory />}
          />
          <Route
            path="/mini-agent-transaction-history"
            element={<MiniAgentTransactionHistory />}
          />
          <Route path="/retail-businesses/wallet" element={<WalletR />} />
          <Route path="/retail-agent/wallet" element={<WalletA />} />
          <Route
            path="/retail-business/transaction"
            element={<TransactionHistoryR />}
          />
          <Route
            path="/retail-agent/transaction"
            element={<TransactionHistoryA />}
          />
          <Route path="privacy-policy-r" element={<PrivacyPolicyR />} />
          <Route path="privacy-policy-a" element={<PrivacyPolicyA />} />
          <Route path="terms-conditions-r" element={<TermsServiceR />} />
          <Route path="terms-conditions-a" element={<TermsServiceA />} />
         {/*  <Route path="/customer/refer-customer" element={<ReferCustomer />} /> */}
          <Route
            path="/business-agent-referral-history"
            element={<BusinessAgentReferralHistory />}
          />
          <Route
            path="/agent-referral-history"
            element={<AgentReferralHistory />}
          />
          <Route path="retailer-business-agent" element={<AgentLayout />}>
            <Route index element={<ReferralPage />} />
            <Route path="refer" element={<ReferralPage />} />
            <Route path="wallet" element={<RetailerAgentWallet />} />
            <Route path="referral-history" element={<ReferralHistory />} />
            <Route path="card-collection" element={<PremiumCardCollection />} />
            
            <Route path="refer-agent" element={
              <ProtectedRoute>
                <ReferAgent />
              </ProtectedRoute>
              } />
            <Route path="edit-profile" element={<EditProfile />} />
          </Route>
          <Route path="/retail-business" element={<BusinessLayout />}>
            <Route index element={<RetailBusinessWallet />} />
            <Route path="wallet" element={<RetailBusinessWallet />} />
            <Route path="card-collection" element={<PremiumCardCollection />} />
            <Route path="transaction-window" element={<ManualTopCoinWindow />} />
            <Route path="edit-profile" element={<EditProfile />} />
          </Route>
          <Route path="/customer" element={<CustomerLayout />}>
            <Route index element={<CustomerWallet />} />
            <Route path="wallet" element={<CustomerWallet />} />
            <Route path="edit-profile" element={<EditProfile />} />
            <Route path="refer-customer" element={<ReferCustomer />} />
            <Route path="referral-history" element={<CustomerReferralHistory />} />
            <Route path="become-agent" element={<BecomeAgent />} />
            <Route path="wallet-network" element={<CustomerWalletNetwork />} />
            <Route path="qr-scan" element={<QrScanner />} />
            <Route path="card-collection" element={<PremiumCardCollection />} />
            <Route path="captain-tc-card" element={<CaptainTCCard />} />
            <Route path="captain-tc-card-agent" element={<CaptainTCCardAgent />} />
          </Route>
          <Route path="/member" element={<MemberLayout />}>
            <Route index element={<MemberWallet />} />
            <Route path="wallet" element={<MemberWallet />} />
            <Route path="card-collection" element={<PremiumCardCollection />} />
            <Route path="edit-profile" element={<EditProfile />} />
          </Route>
          <Route path="member-signup" element={<CreateMember />} />
          <Route path="member-login" element={<MemberLoginPage />} />
          <Route path="verify-email-m" element={<VerifyEmailM />} />
          <Route path="forgot-password-m" element={<ForgotPasswordM />} />
          <Route path="verify-email-mp" element={<VerifyEmailMP />} />
          <Route path="create-new-password-m" element={<CreateNewPasswordM />} />
          <Route path="/captain-tc-cards" element={<CaptainTCCards/>}/>
          <Route path="/purchase" element={<PurchasePage/>}/>
          <Route path="/purchase/cart" element={<PurchaseCartPage/>}/>
          <Route path="/captain-tc-cashback-card-terms" element={<CaptainTCCashbackCardTermsPage/>}/>
          <Route path="/active-retailers" element={<ActiveRetailers/>}/>
          <Route path="/my-wallet" element={<MyWalletPage/>}/>
          <Route path="/customer-senior-mini-agents" element={<SeniorAgentsHierarchyPage/>}/>
          <Route path="/business-senior-mini-agents" element={<BusinessAgentsHierarchyPage/>}/>
          
          {/* Account Admin Routes */}
          <Route path="/account-admin/login" element={<AccountAdminLogin />} />
          <Route path="/account-admin" element={<AccountAdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="users" element={<ManageUsers />} />
            <Route path="requests" element={<CashbackRequests />} />
            <Route path="requests/:id" element={<CustomerCashbackDetails />} />
            <Route path="history" element={<DistributionHistory />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
